import React from "react"

// Styles
import useGlobalStyles from "../../../theme/modern/globalStyles"
import useStyles from "./styles"

/**
 * Root chrome for the Modern skin.
 *
 * Deliberately does NOT render the app bar: each Modern page mounts its own
 * <ModernAppBar/>, exactly as the prototype does, because the record page
 * needs to pass its file-name/meta block into the bar as children and the
 * sign-in page needs no bar at all.
 *
 * Mounting the `@global` sheet here (rather than at the theme provider) means
 * JSS detaches every base-element rule the moment the user flips back to
 * Classic, so Classic can never inherit Modern's body background or font.
 */
export default function ModernShell(props: {children: React.ReactNode}) {
    useGlobalStyles();
    const styles = useStyles();

    return (
      <div className={styles.root}>
          {props.children}
      </div>
    )
}
